
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M1.5 13.339V9.362m0 0h3.818m-3.818 0 2.953 2.89a5.7 5.7 0 0 0 2.46 1.513c.929.28 1.91.31 2.854.088a5.65 5.65 0 0 0 2.541-1.36 6 6 0 0 0 1.595-2.469M15.5 3.162v3.976m0 0h-3.937m3.937 0-2.953-2.89a5.7 5.7 0 0 0-2.46-1.513 5.5 5.5 0 0 0-2.854-.088 5.65 5.65 0 0 0-2.541 1.36 6 6 0 0 0-1.595 2.469"}})])
          )
        }
      }
    